import { Facebook, MessageSquare } from "lucide-react";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-current" aria-hidden="true">
    <path d="M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.8 22H1.7l8.1-9.3L1 2h7l4.8 6.3L18.9 2Zm-1.2 18h1.9L7.4 3.9H5.4L17.7 20Z" />
  </svg>
);

const btn = "grid h-7 w-7 place-items-center rounded-full border border-slate-700 text-slate-400 hover:border-[#0052FF] hover:text-white transition-colors";

export const ShareButtons = ({ title, url, index }) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  const links = [
    { id: "x", label: "Share on X", href: `https://x.com/intent/post?text=${t}&url=${u}`, icon: <XIcon /> },
    { id: "facebook", label: "Share on Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, icon: <Facebook className="h-3.5 w-3.5" /> },
    { id: "sms", label: "Share by text message", href: `sms:?&body=${encodeURIComponent(`${title} ${url}`)}`, icon: <MessageSquare className="h-3.5 w-3.5" /> },
  ];
  return (
    <div className="flex items-center gap-1.5" data-testid={`share-buttons-${index}`}>
      {links.map((l) => (
        <a key={l.id} href={l.href} target={l.id === "sms" ? undefined : "_blank"} rel="noopener noreferrer"
          aria-label={l.label} title={l.label} data-testid={`share-${l.id}-${index}`} className={btn}>
          {l.icon}
        </a>
      ))}
    </div>
  );
};
